import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import { Link } from "react-router-dom";
import SongList from "./SongList";
import PhotoMethods from "./HelperMethods";
import { useState } from "react";
// import ShareIcon from "../images/arrow-up-from-bracket-solid.svg?react";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { encodeId } from "./HelperMethods";
import TextCardComponent from "./Common/TextCardComponent";
import TagComponent from "./Common/TagComponent";
import UserRatingUI from "./Common/UserRatingUI";
import AlbumReviewsContainer from "./Review/AlbumReviewsContainer";

const AlbumDetails: React.FC<AlbumDetailsProps> = ({ album, infos, songs }) => {
  const releaseDate = album.release_date ? album.release_date.slice(0, 10) : "Unknown";
  const tooltip = <Tooltip id="tooltip">copy album link</Tooltip>;
  const copied_tooltip = <Tooltip id="tooltip">copied album url!</Tooltip>;
  const [showCopiedTooltip, setShowCopiedTooltip] = useState(false);

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    setShowCopiedTooltip(true);
    setTimeout(() => {
      setShowCopiedTooltip(false);
    }, 1000);
  };

  // Get artist names for songs
  const getArtistNames = (song: any): string[] => {
    // If the song already has artist_names property, use it
    if (song.artist_names) return song.artist_names;

    // Otherwise use the album's artist(s)
    return infos ? [infos[0]?.english_name || ''] : [''];
  };

  // Helper function to safely convert to string
  const safeToString = (value: any): string => {
    if (value === undefined || value === null) {
      return '';
    }
    return String(value);
  };

  return (
    <div className="album-details">
      <div className="album-left-card">
        <div className="artist-photo-wrapper">
          <img
            className="main-photo"
            src={PhotoMethods(album.s3_picture_url)}
            alt={`album photo of ${album.english_name}`}
            onError={(event: React.SyntheticEvent<HTMLImageElement>) => {
              event.currentTarget.src = "/dubuFace.jpg";
              event.currentTarget.onerror = null;
            }}
          />
        </div>


        {/* Add album rating UI */}
        {album.melon_album_id && (
          <UserRatingUI itemId={album.melon_album_id} itemType="album" />
        )}
      </div>
      <div className="album-right-card">
        <h1 className="main-text">
          {album.english_name}
          {/* <OverlayTrigger
            placement="bottom"
            overlay={showCopiedTooltip ? copied_tooltip : tooltip}
            trigger={["hover", "focus"]}
            rootClose
          >
            <button
              className="share-icon"
              onClick={copyLink}
              style={{ paddingLeft: "1em" }}
            >
              <ShareIcon style={{ display: "flex", width: ".4em" }} />
            </button>
          </OverlayTrigger> */}
        </h1>
        <div className="display-metadata">
          {album.spotify_album_id &&
            <a href={`https://open.spotify.com/album/${album.spotify_album_id}`} target="_blank" rel="noopener noreferrer">
              <img src="/spotify_logo.png" alt="Listen on Spotify" style={{ width: "1em", height: "1em", boxShadow: "none", marginBottom: "0.3em" }} />
            </a>
          }
          {album.album_type && (
            <TagComponent
              text={album.album_type}
              textColor="#eae9f1"
              backgroundColor="rgb(232, 148, 148)"
              fontSize="0.8rem"
              padding="0.1rem 0.8rem"
              className="album-type"
            />
          )}
          {infos &&
            infos.map((info) => (
              <h5 key={info.english_name} className="artist-name">
                <Link
                  to={`/artist/${encodeId(info.melon_artist_id)}`}
                  state={{ id: info.melon_artist_id }}
                  className="a-name-link"
                >
                  {info.melon_artist_id != -1 && info.english_name}
                </Link>
                {info.melon_artist_id == -1 && info.english_name}
              </h5>
            ))}
          <h5>{releaseDate}</h5>
        </div>

        <br />
        <h4 style={{ marginBottom: "0em" }}>tracklist</h4>
        <hr />

        <TextCardComponent
          className="tracklist"
          description={<>
            {songs && songs.map((song) => <SongList key={song._id} song={song} />)}</>
          }
        />
        <br></br>
        {/* <br></br> */}

        {/* Add album reviews section */}
        {album.melon_album_id && (
          <AlbumReviewsContainer albumId={album.melon_album_id} />
        )}
      </div>


    </div >
  );
};

export default AlbumDetails;
